import { Quotes, Check, X } from "@phosphor-icons/react";
import CollapsibleSection from "@/components/admin/CollapsibleSection";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function LegacyWallPanel({ token, legacyPending, setLegacyPending, setError, onRefresh }) {
  const lp = legacyPending || { entries: [], count: 0 };

  const setLegacyStatus = async (photoId, action) => {
    try {
      const r = await fetch(`${BACKEND}/api/sacrifice/legacy-wall/${photoId}/${action}`, {
        method: "POST",
        headers: { "X-Admin-Token": token },
      });
      if (r.ok) {
        setLegacyPending((prev) => ({
          entries: prev.entries.filter((e) => e.id !== photoId),
          count: prev.count - 1,
        }));
      }
    } catch (e) {
      console.error("legacy status update failed:", e);
      setError(`Couldn't update photo: ${e?.message || "network error"}`);
    }
  };

  const badge = lp.count > 0
    ? <span className="text-[10px] uppercase tracking-[0.25em] bg-[#FF1B91] text-white px-2 py-1 font-bold">{lp.count} pending</span>
    : null;

  return (
    <CollapsibleSection
      id="legacy-wall"
      testId="admin-legacy-wall"
      title={<><Quotes size={18} weight="fill" className="text-[#FF1B91] inline mr-2" />Legacy Wall</>}
      badge={badge}
      onRefresh={onRefresh}
      extraActions={<a href="/legacy-wall" onClick={(e) => e.stopPropagation()} className="text-[10px] uppercase tracking-[0.25em] text-white/40 hover:text-[#FF1B91]" target="_blank" rel="noreferrer">View public wall →</a>}
    >
      {(!lp.entries || lp.entries.length === 0) ? (
        <div className="border border-white/10 bg-[#0F0F0F] p-8 text-center text-white/40 text-sm">
          No pending submissions. Approved entries go live on <code className="text-[#FF1B91]">/legacy-wall</code>.
        </div>
      ) : (
        <div className="space-y-3">
          {lp.entries.map((p) => (
            <div key={p.id} data-testid={`legacy-row-${p.id}`} className="border border-[#FF1B91]/60 bg-[#0F0F0F] p-5 grid md:grid-cols-[120px_1fr_auto] gap-4 items-start">
              <div className="aspect-[4/5] bg-black overflow-hidden border border-white/10">
                <img src={`${BACKEND}${p.url}`} alt="" className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div>
                <div className="font-semibold text-white">{p.submitter_name}</div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-white/35 mt-1 break-all">{p.submitter_email} · {p.sharing_consent}</div>
                {p.moving_for_name && <div className="text-sm text-white/85 mt-3">Moving for: <span className="font-semibold">{p.moving_for_name}</span>{p.moving_for_relationship && <span className="text-white/55"> · {p.moving_for_relationship}</span>}</div>}
                {p.caption && <p className="text-white/75 text-sm leading-snug mt-2 whitespace-pre-wrap">{p.caption}</p>}
              </div>
              <div className="flex md:flex-col gap-2">
                <button data-testid={`legacy-approve-${p.id}`} onClick={() => setLegacyStatus(p.id, "approve")} className="text-[10px] uppercase tracking-[0.2em] border border-[#22C55E] text-[#22C55E] hover:bg-[#22C55E]/10 px-3 py-1.5 inline-flex items-center gap-1.5 whitespace-nowrap">
                  <Check size={12} weight="bold" /> Approve
                </button>
                <button data-testid={`legacy-reject-${p.id}`} onClick={() => setLegacyStatus(p.id, "reject")} className="text-[10px] uppercase tracking-[0.2em] border border-white/20 text-white/60 hover:text-white hover:border-white/40 px-3 py-1.5 inline-flex items-center gap-1.5 whitespace-nowrap">
                  <X size={12} weight="bold" /> Reject
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </CollapsibleSection>
  );
}
